const EARTH_RADIUS_METERS = 6378137;

export const DEFAULT_MIN_POLYGON_VERTICES = 3;
export const DEFAULT_CLOSE_DISTANCE_METERS = 20;
export const CLICK_DELAY_MS = 200;
export const SNAP_RADIUS_PX = 18;

export const latLngToLiteral = (
  latLng: google.maps.LatLng
): google.maps.LatLngLiteral => ({
  lat: latLng.lat(),
  lng: latLng.lng(),
});

export const pathToLiterals = (
  path: google.maps.MVCArray<google.maps.LatLng>
): google.maps.LatLngLiteral[] =>
  path.getArray().map(latLng => latLngToLiteral(latLng));

export const normalizePathToLiterals = (
  path: Array<google.maps.LatLng | google.maps.LatLngLiteral>
): google.maps.LatLngLiteral[] =>
  path.map(point => {
    if (typeof (point as google.maps.LatLng).lat === 'function') {
      return latLngToLiteral(point as google.maps.LatLng);
    }

    return {
      lat: (point as google.maps.LatLngLiteral).lat,
      lng: (point as google.maps.LatLngLiteral).lng,
    };
  });

export const computeDistanceMeters = (
  from: google.maps.LatLng,
  to: google.maps.LatLng
): number => {
  if (
    typeof google !== 'undefined' &&
    google.maps.geometry?.spherical?.computeDistanceBetween
  ) {
    return google.maps.geometry.spherical.computeDistanceBetween(from, to);
  }

  const lat1 = (from.lat() * Math.PI) / 180;
  const lat2 = (to.lat() * Math.PI) / 180;
  const deltaLat = ((to.lat() - from.lat()) * Math.PI) / 180;
  const deltaLng = ((to.lng() - from.lng()) * Math.PI) / 180;
  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;

  return 2 * EARTH_RADIUS_METERS * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const isNearLatLng = (
  from: google.maps.LatLng,
  to: google.maps.LatLng,
  maxDistanceMeters: number
): boolean => computeDistanceMeters(from, to) <= maxDistanceMeters;

export const getSnapDistanceMeters = (map: google.maps.Map): number => {
  const zoom = map.getZoom() ?? 15;
  const center = map.getCenter();

  if (!center) {
    return DEFAULT_CLOSE_DISTANCE_METERS;
  }

  const scale = Math.cos((center.lat() * Math.PI) / 180);
  const metersPerPixel =
    (156543.03392 * scale) / Math.pow(2, Math.max(zoom, 1));

  return Math.max(metersPerPixel * SNAP_RADIUS_PX, 8);
};
